export default __webpack_public_path__ + "static/media/pixnotes.7df46e6f.png";